import { useAuth } from '@/contexts/AuthContext';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Crown, ArrowRight } from 'lucide-react';

export function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  
  // Still loading initial auth state - show spinner
  if (loading) {
    return (
      <div className="min-h-screen bg-[#0a0a0f] flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="w-16 h-16 border-4 border-[#D4AF37] border-t-transparent rounded-full animate-spin" />
          <p className="text-white">Loading...</p>
        </div>
      </div>
    );
  }
  
  // Not authenticated - show login prompt
  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-[#0a0a0f] flex items-center justify-center px-4">
        <div className="text-center max-w-md">
          <Crown className="h-16 w-16 text-[#D4AF37] mx-auto mb-6" />
          <h2 className="text-3xl font-bold text-white mb-4">
            Sign In <span className="text-[#D4AF37]">Required</span>
          </h2>
          <p className="text-gray-400 mb-8">
            Please sign in to access this feature and start building your legacy.
          </p>
          <Link to="/login">
            <Button 
              className="bg-[#D4AF37] hover:bg-[#B8962E] text-black px-8 py-6 text-lg"
              data-testid="protected-login-btn"
            >
              Sign In <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
          <p className="mt-4 text-gray-500 text-sm">
            Don't have an account?{' '}
            <Link to="/login" className="text-[#D4AF37] hover:underline">
              Create one for free
            </Link>
          </p>
        </div>
      </div>
    );
  }
  
  // Authenticated - render children
  return children;
}

export default ProtectedRoute;
